"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./LoadingBar.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoadingBar = function LoadingBar() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-loading-progress-bar"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-loading-progress-carga"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-loading-progress-gradiente"
  })));
};

var _default = LoadingBar;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/LoadingBar/LoadingBar.js
// module id = 1907
// module chunks = 0